import React from 'react'
import { Box, IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import HtmlTooltip from '../tooltip/HtmlTooltip';
import { useGetSessionQuery } from '../../api/apiSlice';
import items from '../../utils/navItems'
import { useSelector } from 'react-redux';
import { getSelectedAccount } from '../../redux/selectedAccountSlice';

const NavigationIcons = () => {
  const navigate = useNavigate();
  const API_URL = import.meta.env.PUBLIC_RECALC;
  const { data, error, isLoading, refetch } = useGetSessionQuery();
  const selectedAccount = useSelector(getSelectedAccount)
  const isAdmin = data?.claims?.['accounts.superuser'] === "True" || false;

  const { t } = useTranslation('glossary');
  const hasService = (service) => {
    if (service === undefined) return true
    if (selectedAccount.Services?.some(s => s.Name === service)) return true
    return false
  }

  const renderIconButton = (Icon, title, tooltip, onClick, show = true, additionalContent = null) =>
    show ? (
      <HtmlTooltip key={title} title={tooltip} placement="right">
        <IconButton onClick={onClick} sx={{ m: 1, borderRadius: 1 }}>
          {Icon}
        </IconButton>
      </HtmlTooltip>
    ) : null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
      {items.map((item) => {
        if (item.title === 'monitor') return null
        if (item.isAdmin && !(isAdmin)) return null
        if (!hasService(item.service) && !isAdmin) return null

        const handleClick = () => {
          if (item.title === 'energyxplorer') {
            // legacy beta chip can go here if desired
          }

          if (item.title === 'data-inspector') {
            window.location.href = `${API_URL}/Data/View`
          } else {
            navigate(`${item?.path ? item.path : `/${item.title}`}`)
          }
        }

        return renderIconButton(item.icon, item.title, t(`glossary:${item.title}`) || item.title, handleClick)
      })}
    </Box>
  )
}

export default NavigationIcons
